import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Rating } from 'src/app/models/rating';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-rating-block',
  templateUrl: './rating-block.component.html',
  styleUrls: ['./rating-block.component.scss'],
})
export class RatingBlockComponent implements OnInit, OnChanges {
  @Input()
  rating: Rating;

  oneBarValue: number;
  twoBarValue: number;
  threeBarValue: number;
  fourBarValue: number;
  fiveBarValue: number;
  textDirection: string;

  constructor(private localeService: LocaleService) {
    this.textDirection = localeService.getTextDirection();
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.rating = changes.rating.currentValue;
    this.setStarValues();
  }

  private setStarValues(): void {
    this.oneBarValue = this.calculate(this.rating.totalRatings, this.rating.oneStar);
    this.twoBarValue = this.calculate(this.rating.totalRatings, this.rating.twoStars);
    this.threeBarValue = this.calculate(this.rating.totalRatings, this.rating.threeStars);
    this.fourBarValue = this.calculate(this.rating.totalRatings, this.rating.fourStars);
    this.fiveBarValue = this.calculate(this.rating.totalRatings, this.rating.fiveStars);
  }

  private calculate(total: number, n: number): number {
    return (n * 100) / total;
  }
}
